<template>
  <div class="background">
  <div class="chart-container">
    <div @click="printPdf" class="noPrint">{{$t('print')}}</div>
    <div class="Hcp-main-header">
      <div class="main-header-left">
        <img src="../../assets/LOGO.png">
      </div>
      <div class="main-header-right">
        <p>{{$t('sensorOlRe')}}</p>
        <p style="font-size: 9px;">{{$t('period')}}: {{timeRange3}}</p>
      </div>
    </div>
    <table class="status-table1" :class="{'zh1':!isEn,'de1':isDe||isIt||isFr}">
      <tr>
        <td class="td1 td2">{{$t('uername')}}</td><td colspan="4" class="td2">{{statics.username}}</td>
        <td class="td1 td2">{{$t('fullName')}}</td><td colspan="4" class="td3">{{statics.name}}</td>
      </tr>
      <tr>
        <td rowspan="3" class="td1 td2">{{$t('devices')}}</td>
        <td class="td2" id="reportPdmTitle">{{$t('pdm')}}</td><td colspan="8" class="td3">{{devices[0]}}</td>
      </tr>
      <tr><td class="td2">{{$t('tran')}}</td><td colspan="8" class="td3">{{devices[1]}}</td></tr>
      <tr><td class="td2">{{$t('pumpBase')}}</td><td colspan="8" class="td3">{{devices[2]}}</td></tr>
      <tr>
        <td class="td1 td4">{{$t('disType')}}</td><td colspan="4" class="td4">{{statics.medical_history}}</td>
        <td class="td td4">{{$t('HbA1c')}}</td><td colspan="4">{{hb1c[0]}}</td>
      </tr>
    </table>

    <div class="small-hr"></div>
    <div element-loading-text="Loading" v-loading.fullscreen.lock="loading" >
    <div id="chart3_1" class="graph"></div>
    </div>

    <div class="spe-hr"></div>

    <div class="legend-group">
      <div class="legend" v-show="show.A"><img src="../../assets/Line_1.png"><span>{{legendDate[0]}}</span></div>
      <div class="legend" v-show="show.B"><img src="../../assets/Line_2.png"><span>{{legendDate[1]}}</span></div>
      <div class="legend" v-show="show.C"><img src="../../assets/Line_3.png"> <span>{{legendDate[2]}}</span></div>
      <div class="legend" v-show="show.D"><img src="../../assets/Line_4.png"><span>{{legendDate[3]}}</span></div>
      <div class="legend" v-show="show.E"><img src="../../assets/Line_5.png"><span>{{legendDate[4]}}</span></div>
      <div class="legend" v-show="show.F"><img src="../../assets/Line_6.png"><span>{{legendDate[5]}}</span></div>
      <div class="legend" v-show="show.G"><img src="../../assets/Line_7.png"><span>{{legendDate[6]}}</span></div>
      <div class="legend" style="margin-bottom: 30px;"><img src="../../assets/Average.png"><span>{{$t('Average')}}</span></div>
    </div>
    <div class="statics">
      <table class="statics-table">
        <tr>
          <td class="td1">{{$t('date')}}</td><td class="td1">{{$t('Avg')}}</td> <td class="td1">{{$t('min')}}</td>
          <td class="td1">{{$t('max')}}</td> <td class="td2">{{$t('ofhypo')}}</td>
        </tr>
        <tr v-for="(item,i) in date" v-show="item">
          <td class="td1">{{item}}</td><td class="td1">{{glucose[i].avg}}</td>
          <td class="td1">{{glucose[i].min}}</td><td class="td1">{{glucose[i].max}}</td> <td class="td2">{{glucose[i].nh}}</td>
        </tr>
        <tr>
          <td class="td3">{{$t('overall')}}</td> <td class="td3">{{glucose[glucoseLength].avg}}</td> <td class="td3">{{glucose[glucoseLength].min}}</td>
          <td class="td3">{{glucose[glucoseLength].max}}</td> <td>{{glucose[glucoseLength].nh}}</td>
        </tr>
      </table>
    </div>
    <div class="page-end"></div>
  </div>
  </div>
</template>

<script>
  import * as echarts from 'echarts'
  import auth from '../../auth/auth'
  import format from '@/lib/format'
  import B64 from '../../auth/base64'
  export default{
    data() {
      return {
        statics:{},devices:['--','--','--'],hb1c:['--'],isMg:'',ts:[],avg:[],
        glucose:[[],[],[],[],[],[],[],[]],
        chartWidth: '', timer: false,typeChooseVisible:false, value1:'',isC:false, flag:0,count:0, sta:'',end:'',Average:[],
        chart3_1: null, startDate:'',  timeRange3:'',defaultDate:'',whichDay:' Everyday', weekmode:'yyyyyyy',
        legendDate:['','','','','','',''], Kday:[],DataSG:[],calib:[],bg:[],isEn:false,isFr:false,
        show:{A:false,B:false,C:false,D:false,E:false,F:false,G:false,},
        uid:0,st:0,et:0, startTine:1505836800000,loading:true,glucoseLength:7,date:[],isDe:false,isIt:false,
        pickerOptions:{
          disabledDate(time){
            return time.getTime()>Date.now();
          }
        },
        textStyle: {
          color: '#282828',
          fontWeight: 'normal',
          fontSize: '14',
          fontFamily: 'SFUIText-Regular'
        },
        titlePadding: [0, 0, 8, 33],
        grid: {x: '3%', y: '4%', width: '94.5%', height: '89%'},
        yAxisLabel: {interval: 0, margin: 5, textStyle: {color: '#282828', baseline: 'middle'}, showMinLabel: false},
      }
    },
    computed: {
      DataS(){
        return this.$store.state.DataS;
      },
    },
    methods:{
      drawChart3_1() {
        let that=this;
        self.document.title = this.$t('sensorOlRe');
        this.chart3_1 = echarts.init(document.getElementById('chart3_1'));
        this.chart3_1.setOption({
          title: {
            text: (this.isMg)? this.$t('SG')+' (mg/dL)':this.$t('SG')+' (mmol/L)',
            textStyle: this.textStyle,
            padding: this.titlePadding,
          },
          xAxis: [{
            type: 'time',
            boundaryGap: false,
            min:new Date(this.startTime),
            max:new Date(this.startTime+8.64e7),
            axisLine: {lineStyle: {color: '#ccc'}},
            splitNumber: 24,
            splieLine:{show:true},
            axisLabel:{
              showMaxLabel:true,
              margin: 15, textStyle: {color: '#282828', baseline: 'middle'} ,
              formatter:function (value,index) {
                // let H = new Date(value).getHours();
                index=(value - that.startTime) / 3600000;
                let H=index;
                if(index<24){
                  if(index%3===0){
                    H = H<10 ? ('0'+H+':00' ): H+':00';
                    return  H;
                  }else{
                    return ' ';
                  }
                }else{
                  return  '24:00';
                }
              }
            },
          }],
          yAxis: [{
            type: 'value',
            min:0,max:(this.isMg)? 400:25,
            axisLabel: this.yAxisLabel,
            axisLine: {lineStyle: {color: '#ccc'}},
            boundaryGap: false,
            axisTick: {length: 0},
          }],
          grid: this.grid,
          animation:false,
          series: [
            {
              type:'scatter',
              data:this.DataSG[0],
              markArea: {
                data: [ [{yAxis: (this.isMg)?this.DataS.target_low*18:this.DataS.target_low}, {yAxis:(this.isMg)?this.DataS.target_high*18:this.DataS.target_high}]],
                silent:true,
                itemStyle: {normal: {color: 'rgba(211,255,213,0.6)',},}
              },
              markLine: {
                data: [{ yAxis:(this.isMg)?this.DataS.hypo*18:this.DataS.hypo}],
                symbol:['circle','circle'],
                symbolSize: 1,
                silent:true,
                lineStyle: {normal: {
                  color: 'rgba(255,0,0,0.5)',
                  type: 'solid',
                }},
                label:{normal:{show:false}},
              },
              itemStyle: {normal: {color:'#3ce8dc',}},
              symbolSize:3,
            },
            {
              type:'scatter',
              data:this.DataSG[1],
              itemStyle: {normal: {color:'#2842d2',}},
              symbolSize:3,
            },
            {
              type:'scatter',
              data:this.DataSG[2],
              itemStyle: {normal: {color:'#79bd39',}},
              symbolSize:3,
            },
            {
              type:'scatter',
              data:this.DataSG[3],
              itemStyle: {normal: {color:'#dce573',}},
              symbolSize:3,
            },
            {
              type:'scatter',
              data:this.DataSG[4],
              itemStyle: {normal: {color:'#e61795',}},
              symbolSize:3,
            },
            {
              type:'scatter',
              data:this.DataSG[5],
              itemStyle: {normal: {color:'#c9711e',}},
              symbolSize:3,
            },
            {
              type:'scatter',
              data:this.DataSG[6],
              itemStyle: {normal: {color:'#a922d9',}},
              symbolSize:3,
            },
            {
              type:'scatter',
              data:this.avg,
              itemStyle: {normal: {color:'#464646',}},
              tooltip:{backgroundColor:'#777',
                formatter:function(params){
                  let date = params.value[0];
                  let time = format.formatterDate5(date);
                  if(params.value[1]>0){
                    if(params.value[2]==='CX'){
                      return  time[0]+':'+time[1]+', '+params.value[1]+
                        '<hr style="width: 17px;background:#000;height:1px;border:none;margin-left: 42px;">';
                    }
                    return  time[0]+':'+time[1]+', '+params.value[1];
                  }
                  else{
                    if(params.value[2]==='NC'){
                      return time[0]+':'+time[1]+', Not Calibrated';
                    }
                    if(params.value[2]==='DE'){
                      return time[0]+':'+time[1]+', No Readings';
                    }
                    if(params.value[2]==='CE0'||params.value[2]==='CE1'){
                      return time[0]+':'+time[1]+',Calib Error';
                    }
                    return time[0]+':'+time[1]+', warm up';
                  }
                },
                textStyle:{color:'#fff'}
              },
              symbolSize:3,
            },
            {
              type: 'scatter',
              data: this.calib,
              symbol:'image://static/legend/calib.png',
            },
            {
              type: 'scatter',
              data: this.bg,
              symbol:'image://static/legend/calibrate_1.png',
            },
          ],
        },false,true);
      },
      checkLegend(){
        let  legendTime =this.DataSG;
        this.legendDate =['','','','','','',''];
        this.show = {A:false,B:false,C:false,D:false,E:false,F:false,G:false,};
        for(let i=0;i<legendTime.length;i++){
          if(legendTime[i]){
            let time = legendTime[i][0][0];
            time =new Date(time);
            let y1 = time.getFullYear();
            let m1 = time.getMonth()+1;
            let d1 = time.getDate();
            d1 = d1+this.Kday[i];
            if((m1===1||m1===3||m1===5||m1===7||m1===8||m1===10||m1===12)&&d1>31){
              d1 = d1-31;
              m1 = m1+1;
            }
            if((m1===4||m1===6||m1===9||m1===11)&&d1>30){
              d1 = d1-30;
              m1 =m1+1;
            }
            if((m1===2)&&d1>29){
              d1 = d1-29;
              m1 =m1+1;
            }
            if(m1>12){
              m1 =m1-12;
              y1 = y1+1;
            }
            m1 = m1<10 ? ('0'+m1 ): m1;
            d1 = d1<10 ? ('0'+d1) : d1;

            this.legendDate[i] =d1+'-'+m1+'-'+y1;
          }
        }
        if(this.legendDate[0]!==''){this.show.A = true;}
        if(this.legendDate[1]!==''){this.show.B = true;}
        if(this.legendDate[2]!==''){this.show.C = true;}
        if(this.legendDate[3]!==''){this.show.D = true;}
        if(this.legendDate[4]!==''){this.show.E = true;}
        if(this.legendDate[5]!==''){this.show.F = true;}
        if(this.legendDate[6]!==''){this.show.G = true;}

        let length = this.ts.length;
        this.glucoseLength = length;
        for(let i=0;i<length;i++){
          let t = format.formatterDate9(this.ts[i][0]);
          t[1] = t[1]+1;
          t[1]=  t[1]<10 ? ('0'+ t[1] ):  t[1];
          t[2] = t[2]<10 ? ('0'+ t[2]) :  t[2];
          this.date[i] = t[2]+'-'+t[1]+'-'+t[0];
        }
      },
      getOlReportInfo(report_data) {
        let data =  report_data;
        data.medical_history = (data.medical_history )?this.$t(data.medical_history):"--";
        this.statics = data;
        this.devices = (data.devices)?data.devices:this.devices;
        if ('EasyPatch'==this.devices[0]) {
          document.getElementById('reportPdmTitle').innerHTML='APP';
        }
        this.hb1c = (data.hba1c)?data.hba1c:this.hb1c;
        this.glucose = (data.sg_stat)?data.sg_stat:this.glucose;
      },
      getStatics(param){
        this.$http.get('api/v2.1/report/'+this.uid+'/data/ol',{params:{param}}).then(function (res) {
          let err =res.body.error;
          if(err === 0){
            let data =  res.data.data;
            data.medical_history = (data.medical_history )?this.$t(data.medical_history):"--";
            this.statics = data;
            this.devices = (data.devices)?data.devices:this.devices;
            this.hb1c = (data.hba1c)?data.hba1c:this.hb1c;
            this.glucose = (data.sg_stat)?data.sg_stat:this.glucose;
          }
        },function(err){
          let tip =  this.$t('tryAgain');
          this.$message.error(tip);
        })
      },
      openFullScreen(){
        this.loading = true;
        setTimeout(()=>{
          this.loading = false;
        },3000);
      },
      getAverage(SG){
        // console.log(SG);
        let length=SG.length;
        let average = new Array(720);
        for(let j=0;j< 720;j++) {
          average[j] = new Array(2);
          average[j][0] = parseInt(this.startTime/1000)+j*120;
          average[j][1] =0;
          let num=0;
          for (let i = 0; i < length; i++) {
            //遍历所有元素，根据时间查找
            for(let k=0;k<720;k++){
              if(SG[i][k]){
                let t = SG[i][k][0].getTime()/1000;
                let mt = t-average[j][0];
                if(mt<=120&&mt>=0){
                  average[j][1] =  average[j][1] + SG[i][k][1];
                  num++;
                }
              }
            }
          }
          average[j][0] = new Date(average[j][0]*1000);
          average[j][1] = (average[j][1]/num).toFixed(1);
        }
        this.avg = average;
        //console.log(this.avg)
      },
      printPdf(){
        auth.print_page();
      },
    },
    mounted: function () {
      this.openFullScreen();
      let lang = sessionStorage.getItem('language');
      this.isEn = (lang!=='zh'&&lang !=='hk')?true:false;
      this.isDe = (lang==='de')?true:false;
      this.isIt = (lang==='it')?true:false;
      this.isFr = (lang==='fr')?true:false;
      this.isMg = (localStorage.getItem('unit')==='mg')?true:false;
      this.et= parseInt(sessionStorage.getItem('qet3'));
      this.st= parseInt(sessionStorage.getItem('qst3'));
      this.weekmode = sessionStorage.getItem('qweekMode');
      this.timeRange3 = format.formatterDate2(this.st)+' - '+format.formatterDate2(this.et);
      this.ts = auth.getTs2(this,this.st,this.et);
      let param = {
        ts:this.ts,
        tz:parseInt(sessionStorage.getItem('tz')),
        weekmode:this.weekmode,
        gu:(this.isMg)?'mg/dL':'mmol/L',
      };
      if(sessionStorage.getItem('userType')!=='P'){
        this.uid = parseInt(sessionStorage.getItem('patientId'));
      }else{
        this.uid = parseInt(sessionStorage.getItem('uid'));
      }
      param = B64.base64encode(JSON.stringify(param));
      //this.getStatics(param);
      auth.getOl(this,this.uid,param);
      let first = parseInt(sessionStorage.getItem('qFirst3'));
      if(first===1){
        auth.checkPrint(this,4,3);
      }
    },
  }
</script>

<style scoped meadia="print">
  @page{
    *size:auto;
    size:portrait;
    margin: 0;
  }
  .background{
    padding-top: 5mm;
    width: 100%;
    *height: 296mm;
    background: #ccc;
  }
  .background .noPrint{
    float: left;
    border-radius:100px;
    background: #fff;
    border: 1px solid #a3a3a3;
    outline: none;
    margin-top:4px;
    width:90px;
    height:26px;
    line-height: 28px;
    cursor: pointer;
    margin-left:-140px;
    font-size: 13px;
    text-align: center;
  }
  @media print {
    .background .noPrint{
      display: none;
    }
  }
  .chart-container {
    width:210mm;
    *height:296mm;
    font-family:SFUIText-Regular;
    font-size:12px;
    color:#282828;
    letter-spacing:-0.34px;
    background: #fff;
    margin:0 auto;
    padding-left: 20px;
    padding-right: 20px;
  }
  .Hcp-main-header{
    width:97%;
    height:40px;
    margin:0 auto;
    font-family:SFUIText-Regular;
    font-size:12px;
    color:#282828;
    padding-top: 10px;
  }
  .main-header-left{
    float: left;
  }
  .main-header-left img{
    height:45px;
    width: 100px;
  }
  .main-header-right{
    float: right;
    text-align: right;
    padding-top: 10px;
    margin-right: 15px;
  }
  .main-header-right p{
    font-size:12px;
    margin-bottom: 5px;
    letter-spacing:-0.29px;
    font-family:SFUIText-Regular;
    color:#282828;
  }
  .status-table1{
    width: 94%;
    margin:20px auto 16px;
    border:1px solid #747474;
    font-family:SFUIText-Regular;
    border-collapse: collapse;
    text-align:left;
    table-layout: fixed;
  }
  .status-table1 td{
    padding-left: 10px;
    height:15px;
  }
  .status-table1 .td1{
    width: 14%;
  }
  .zh1 .td1{
    width: 12%;
  }
  .de1 .td1{
    width: 11%;
  }
  .de1 td{
    padding-left: 3px;
  }
  .status-table1 .td2{
    border-bottom:1px solid rgba(116,116,116,0.34);
    border-right:1px solid rgba(116,116,116,0.34);
  }
  .status-table1 .td3{
    border-bottom:1px solid rgba(116,116,116,0.34);
  }
  .status-table1 .td4{
    border-right:1px solid rgba(116,116,116,0.34);
  }

  .small-hr{
    width:94%;
    margin:10px auto 16px;
    border-top:1px solid #3b3b3b;
  }
  .spe-hr{
    width:94%;
    border-top:1px solid #e6e8ea;
    margin:20px auto 20px;
  }
  .chart-container .graph{
    width:97%;
    height:540px;
    margin-left: 2%;
    margin-bottom: 5px;
  }

  .legend-group{
    width:98%;
    margin-left: 3%;
    font-family:SFUIText-Regular;
    font-size:10px;
    color:#282828;
    letter-spacing:-0.39px;
    text-align:left;
  }
  .legend{
    float:left;
    margin-bottom: 8px;
    margin-right:50px;
    height:20px;
    line-height: 20px;
  }
  .legend img{
    margin-right: 8px;
    margin-bottom: 4px;
  }

  .statics{
    clear: both;
  }
  .statics-table{
    width: 94%;
    margin:0 auto;
    border:1px solid #747474;
    font-family:SFUIText-Regular;
    border-collapse: collapse;
    text-align:center;
    table-layout: fixed;
  }
  .statics-table td{
    height:17px;
  }
  .statics-table .td1{
    border-bottom:1px solid rgba(116,116,116,0.34);
    border-right:1px solid rgba(116,116,116,0.34);
  }
  .statics-table .td2{
    border-bottom:1px solid rgba(116,116,116,0.34);
  }
  .statics-table .td3{
    border-right:1px solid rgba(116,116,116,0.34);
  }
  .page-end {
    clear: both;
    height:10mm;
  }
</style>



// WEBPACK FOOTER //
// quickPrint3.vue?58a626ce